import { _ } from '@ngx-translate/core';

export const PRODUCT_CAPTIONS: Record<string, string> = {
  name: _('components.lpAllStatistics.constants.productCaptions.name'),
  datePublished: _('components.lpAllStatistics.constants.productCaptions.datePublished'),
  listCount: _('components.lpAllStatistics.constants.productCaptions.listCount'),
  readCount: _('components.lpAllStatistics.constants.productCaptions.readCount'),
  linksVisitedCount: _('components.lpAllStatistics.constants.productCaptions.linksVisitedCount'),
  discountsUsedCount: _('components.lpAllStatistics.constants.productCaptions.discountsUsedCount'),
};

export const DISCOUNT_CAPTIONS: Record<string, string> = {
  name: _('components.lpAllStatistics.constants.discountCaptions.name'),
  discountDate: _('components.lpAllStatistics.constants.discountCaptions.discountDate'),
  userName: _('components.lpAllStatistics.constants.discountCaptions.userName'),
  discount: _('components.lpAllStatistics.constants.discountCaptions.discount'),
};
